import { Component, Inject } from '@angular/core';
import { CONST } from '../end-outbound-scan-gle.constant';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-end-scan-successful-modal',
  templateUrl: './end-scan-successful-modal.component.html',
  styleUrls: ['./end-scan-successful-modal.component.scss'],
  standalone: false,
})
export class EndScanSuccessfulModalComponent {
  readonly CONST = {
    ...CONST.END_SCAN_SUCCESS_MODAL,
  };
  message = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { index: number; message: string },
    public dialogRef: MatDialogRef<EndScanSuccessfulModalComponent>,
  ) {
    this.message = this.data.message || CONST.END_SCAN_SUCCESS_MODAL.MESSAGE;
  }

  /**
   * Close the modal and remove record from table
   *
   * @memberof EndScanSuccessfulModalComponent
   */
  ok() {
    this.dialogRef.close();
  }
}
